import { createFileRoute, Link } from '@tanstack/react-router';
import { useQuery } from '@tanstack/react-query';
import { api, unwrap } from '@/lib/api';
import { Database } from 'lucide-react';

interface PostType {
  id: number;
  key: string;
  label_singular: string;
  label_plural: string;
  icon: string | null;
  public: boolean;
}

export const Route = createFileRoute('/_app/post-types/')({
  component: PostTypesPage,
});

function PostTypesPage() {
  const { data, isLoading } = useQuery({
    queryKey: ['post-types'],
    queryFn: () => unwrap<PostType[]>(api.get('/post-types')),
  });

  return (
    <div className="p-8">
      <header className="mb-6">
        <h1 className="text-2xl font-bold">Tipos de contenido</h1>
        <p className="text-sm text-neutral-500">
          Custom Post Types configurados en este sitio.
        </p>
      </header>

      {isLoading && <div className="text-sm text-neutral-500">Cargando…</div>}

      <div className="grid grid-cols-3 gap-3">
        {data?.map((pt) => (
          <Link
            key={pt.key}
            to="/post-types/$key/posts"
            params={{ key: pt.key }}
            className="rounded-lg border border-neutral-200 bg-white p-4 hover:border-neutral-400"
          >
            <div className="mb-2 flex items-center gap-2">
              <Database className="size-4 text-neutral-500" />
              <span className="font-semibold">{pt.label_plural}</span>
            </div>
            <div className="text-xs text-neutral-500">/{pt.key}</div>
          </Link>
        ))}
      </div>
    </div>
  );
}
